import withUiBase from './withUiBase';

function SelectUIBase({ uiBase, children }) {
  if (uiBase === 'kiddie') {
    return children[0];
  }
  return children[1];
}

export default withUiBase(SelectUIBase);
